export function validateField(field) {
  let isValid = true;
  const errorMsgWrapper = field.closest('.input-control').querySelector('.form-input-error');

  if (field.value === '') {
    isValid = false;
    field.classList.add('error');
    errorMsgWrapper.innerText = errorMsgWrapper.dataset.requiredError;

  } else if (field.type === 'email') {
    const re = /\S+@\S+\.\S+/;

    if (!re.test(field.value)) {
      isValid = false;
      field.classList.add('error');
      errorMsgWrapper.innerText = errorMsgWrapper.dataset.emailFormatError;
    } else {
      field.classList.remove('error');
      errorMsgWrapper.innerText = '';
    }

  } else if (field.type === 'tel') {
    isValid = validatePhone(field);

  } else if (field.name === 'postal_code') {
    const re = /^[a-zA-Z]\d[a-zA-Z][ \-]?\d[a-zA-Z]\d$/;
    if (!re.test(field.value)) {
      isValid = false;
      field.classList.add('error');
      errorMsgWrapper.innerText = errorMsgWrapper.dataset.postalcodeFormatError;
    } else {
      field.classList.remove('error');
      errorMsgWrapper.innerText = '';
    }

  } else if (field.type === 'checkbox') {
    if (!field.checked) {
      isValid = false;
      field.classList.add('error');
      errorMsgWrapper.innerText = errorMsgWrapper.dataset.requiredError;
    } else {
      field.classList.remove('error');
      errorMsgWrapper.innerText = '';
    }

  } else if (field.type === 'radio') {
    const radios = document.getElementsByName(field.name);
    const isChecked = Array.from(radios).some((radio) => radio.checked);

    if (!isChecked) {
      isValid = false;
      field.classList.add('error');
      errorMsgWrapper.innerText = errorMsgWrapper.dataset.requiredError;
    } else {
      field.classList.remove('error');
      errorMsgWrapper.innerText = '';
    }

  } else if (field.type === 'file') {
    const allowedExtensions = ['docx', 'doc', 'pdf', 'txt', 'rtf'];
    const file = field.files[0];

    if(file) {
      const fileName = file.name.toLowerCase();
      const fileExt = fileName.split('.').pop();

      if (!allowedExtensions.includes(fileExt)) {
        isValid = false;
        field.classList.add('error');
        errorMsgWrapper.innerText = errorMsgWrapper.dataset.fileTypeError;
      } else {
        field.classList.remove('error');
        errorMsgWrapper.innerText = '';
      }
    }
  } else {
    field.classList.remove('error');
    errorMsgWrapper.innerText = '';
  }

  if(field.type === 'radio') {
    field.closest('.input-control').querySelector("fieldset").setAttribute('aria-invalid', isValid ? 'false' : 'true');
  } else {
    field.setAttribute('aria-invalid', isValid ? 'false' : 'true');
  }

  if (!isValid) {
    field.closest('.input-control').classList.add('has-error');
  } else {
    field.closest('.input-control').classList.remove('has-error');
    errorMsgWrapper.innerText = '';
  }

  return isValid;
}

export function validateRequiredFields(form) {
  let isValid = true;
  const requiredFields = form.querySelectorAll('[required]');
  requiredFields.forEach((field) => {
    const valid = validateField(field);
    if (!valid) {
      isValid = false;
      const firstInvalidInput = document.querySelector('.form-input.error');
      firstInvalidInput.focus();
    }
  });
  return isValid;
}

export function validatePhone(field) {
  let isValid = true;
  const errorMsgWrapper = field.closest('.input-control').querySelector('.form-input-error');
  const phone = field.value.replace(/\D/g, '');
  field.value = phone;

  if (phone.length === 0) return isValid;
  if (phone.length < 10) {
    field.classList.add('error');
    errorMsgWrapper.innerText = errorMsgWrapper.dataset.phoneFormatError;
    isValid = false;
  } else {
    field.classList.remove('error');
    errorMsgWrapper.innerText = '';
    field.value = formatPhone(phone);
  }

  return isValid;
}

export function formatPhone(phone) {
  if (phone.length === 10) {
    return phone.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
  }
  if (phone.length === 11) {
    return phone.replace(/(\d{1})(\d{3})(\d{3})(\d{4})/, '$1 ($2) $3-$4');
  }
  return phone;
}

export function validatePhones(form) {
  let isValid = true;
  const phoneFields = form.querySelectorAll(`[type="tel"]`);

  phoneFields.forEach((field) => {
    const valid = validatePhone(field);
    if (!valid) {
      isValid = false;
    }
  });

  return isValid;
}
